import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { receiveKeys } from './keys';

import type { TypePostRequestsRequestedParams, TypePostRequestsRequestedResponse } from '~/types/receive.types';

const fetchRequestsRequested = async (
  ownerCode: string,
  params: TypePostRequestsRequestedParams
): Promise<TypePostRequestsRequestedResponse> => {
  const { data } = await axiosInstance.post<TypePostRequestsRequestedResponse>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/requests/requested`,
    params
  );
  return data;
};

type TypeUsePostRequestsRequestedQueryParams = {
  ownerCode: string;
  params: TypePostRequestsRequestedParams;
  enabled?: boolean;
};

/**
 * [입고관리 > 입고요청관리] 입고요청 목록 조회 Query Hook
 */
export const usePostRequestsRequestedQuery = ({
  ownerCode,
  params,
  enabled = true,
}: TypeUsePostRequestsRequestedQueryParams) => {
  return useQuery({
    queryKey: receiveKeys.requestsRequested(ownerCode, params),
    queryFn: () => fetchRequestsRequested(ownerCode, params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
};
